export enum KEY {
  TAB = 'Tab',
  ESCAPE = 'Escape',
  BACKSPACE = 'Backspace',
  ENTER = 'Enter',
  ARROW_UP = 'ArrowUp',
  ARROW_DOWN = 'ArrowDown',
  ARROW_RIGHT = 'ArrowRight',
  ARROW_LEFT = 'ArrowLeft',
}

export enum CARET {
  TOP = 'Top',
  RIGHT = 'Right',
  BOTTOM = 'Bottom',
  LEFT = 'Left',
}

export enum PARAMETER {
  THRESHOLD = 'threshold',
}

export enum INDICATOR_COLOR {
  PURPLE = 'purple',
  INDIGO = 'indigo',
  GREEN = 'green',
  RED = 'red',
  ORANGE = 'orange',
  WHITE = 'white',
  BLUE = 'blue',
  YELLOW = 'yellow',
  GREY = 'grey',
  CYAN = 'cyan',
  PINK = 'pink',
}

export enum PAIR_OPTION {
  RUN_PAIR = 1,
  PAUSE_PAIR = 2,
  INITIALIZE_CANDLE_WORKER = 3,
  RUN_CANDLE_WORKER = 4,
  PAUSE_CANDLE_WORKER = 5,
  DELETE_CANDLE_WORKER = 6,
  RESET_VALIDATION = 7,
}

export enum STRATEGY_OPTION {
  ACTIVATE_STRATEGY = 1,
  UPDATE_STRATEGY = 2,
  PUBLISH_STRATEGY = 3,
  ARCHIVE_STRATEGY = 4,
}
